import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Sparkles, Headphones, BookOpen } from "lucide-react";
import { api } from "../lib/api";
import { BookCover } from "./BookCover";

export default function FeaturedToday() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/featured/today").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data?.book) return null;
  const b = data.book;
  const today = new Date(data.date + "T00:00:00");
  const dateLabel = today.toLocaleDateString(undefined, { weekday: "long", month: "long", day: "numeric" }).toLowerCase();

  return (
    <motion.section
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="my-14 md:my-20 relative overflow-hidden rounded-lg border border-border bg-card paper-shadow"
      data-testid="today-spine-card"
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-40 pointer-events-none"
        style={{
          background: `radial-gradient(ellipse at 15% 30%, ${b.colors.bg}55, transparent 55%), radial-gradient(ellipse at 90% 90%, ${b.colors.spine}44, transparent 60%)`,
        }}
      />
      <div className="relative grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 p-6 md:p-10 items-center">
        <div className="md:col-span-3 flex justify-center md:justify-start">
          <div className="w-40 md:w-48">
            <BookCover book={b} size="lg" />
          </div>
        </div>
        <div className="md:col-span-9">
          <div className="flex items-center gap-2 font-ui text-xs tracking-caps text-primary mb-3">
            <Sparkles className="w-3.5 h-3.5" /> today&apos;s spine · {dateLabel}
          </div>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl leading-tight tracking-tight">
            {b.title}
          </h2>
          <div className="font-reader italic text-lg text-muted-foreground mt-2">by {b.author}</div>
          {b.synopsis && (
            <p className="font-reader text-base md:text-lg leading-relaxed mt-5 line-clamp-3 max-w-2xl">
              {b.synopsis}
            </p>
          )}
          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to={`/read/${b.id}`}
              data-testid="today-spine-read-btn"
              className="inline-flex items-center gap-2 rounded-full bg-primary text-primary-foreground px-5 py-2.5 font-ui text-sm hover:opacity-90 transition-opacity"
            >
              <BookOpen className="w-4 h-4" /> open the pages
            </Link>
            <Link
              to={`/read/${b.id}?audio=1`}
              data-testid="today-spine-listen-btn"
              className="inline-flex items-center gap-2 rounded-full border border-border px-5 py-2.5 font-ui text-sm hover:bg-secondary transition-colors"
            >
              <Headphones className="w-4 h-4" /> read to me
            </Link>
            <Link
              to={`/book/${b.id}`}
              className="inline-flex items-center gap-2 rounded-full px-5 py-2.5 font-ui text-sm text-muted-foreground hover:text-primary transition-colors"
            >
              more →
            </Link>
          </div>
        </div>
      </div>
    </motion.section>
  );
}
